"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faScrewdriverWrench,
  faUserNurse,
  faLaptopCode,
  faHotel,
  faHelmetSafety,
  faIndustry,
} from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import "./Card_Section.css";

const cardsData = [
  {
    id: 1,
    title: "Skilled Technical Workers",
    description:
      "Engineers, welders, electricians, HVAC technicians, and industrial fitters certified and ready for global deployment.",
    icon: faScrewdriverWrench,
    image: "/assets/images/services_page/card_section/company_img.avif",
  },
  {
    id: 2,
    title: "Healthcare Professionals",
    description:
      "Registered nurses, doctors, lab technicians, and paramedics with complete licensing support for international placements.",
    icon: faUserNurse,
    image: "/assets/images/services_page/card_section/healthcare.jpeg",
  },
  {
    id: 3,
    title: "IT & BPO Professionals",
    description:
      "Software developers, data analysts, and customer service executives for global tech companies and outsourcing needs.",
    icon: faLaptopCode,
    image: "/assets/images/services_page/card_section/It_BPO.jpeg",
  },
  {
    id: 4,
    title: "Hospitality & Retail",
    description:
      "Chefs, housekeeping staff, hospitality managers, and retail professionals for hotels and consumer businesses worldwide.",
    icon: faHotel,
    image: "/assets/images/services_page/card_section/hospitality.jpeg",
  },
  {
    id: 5,
    title: "Oil, Gas & Construction",
    description:
      "Rig workers, safety officers, engineers, and heavy equipment operators for energy and infrastructure projects.",
    icon: faHelmetSafety,
    image:
      "/assets/images/services_page/card_section/oil_gas construction.jpeg",
  },
  {
    id: 6,
    title: "Manufacturing & Industrial",
    description:
      "Factory workers, supervisors, quality control specialists, and machine operators for manufacturing facilities.",
    icon: faIndustry,
    image: "/assets/images/services_page/card_section/industrial.png",
  },
];

function Card_Section() {
  const navigate = useNavigate();

  const handleApplyNow = () => {
    navigate("/new/apply_now");
  };
  return (
    <section className="blog_grid_section">
      <div className="container">
        <div className="blog_grid">
          {cardsData.map((item) => (
            <article className="Blog_card" key={item.id}>
              <div className="img_holder">
                <img className="Blog_img" src={item.image} alt={item.title} />

                <div className="image_gradient"></div>

                <div className="top_icon_badge">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <div className="blog_content">
                  <h3 className="title_text">{item.title}</h3>

                  <div className="para_text">
                    <p>{item.description}</p>
                  </div>

                  <div className="read_more" onClick={handleApplyNow}>
                    <span>Apply Now</span>

                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Card_Section;
